export const MSA_COUNTRY_FIELDS = {
    CH: [{ key: "uidNumber", label: "UID Number" }],
    NG: [{ key: "rcNumber", label: "RC Number" }, { key: "tinNumber", label: "TIN Number" }],
} as const;

export type MsaCountryField = "uidNumber" | "rcNumber" | "tinNumber";

export function msaCountryFields(countryCode: string): readonly { key: MsaCountryField; label: string }[] {
    return MSA_COUNTRY_FIELDS[countryCode.toUpperCase() as keyof typeof MSA_COUNTRY_FIELDS] || [];
}

export function missingMsaCountryField(data: Record<string, unknown>, countryCode: string): string | null {
    for (const field of msaCountryFields(countryCode))
        if (!String(data[field.key] ?? "").trim())
            return field.label;
    return null;
}
